import React from "react";
import { Button, Tooltip } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import StopIcon from "@mui/icons-material/Stop";
import { GUIDED_TOUR_ACTION_BUTTON_SX } from "./guidedTourPopoverStyles";

export default function GuidedTourListenButton({
  text,
  isSpeaking,
  isMuted,
  speechSupported,
  narrationEnabled,
  onListen,
  onStop,
}) {
  if (!narrationEnabled) {
    return null;
  }

  const disabled = !text || isMuted || !speechSupported;
  const label = isSpeaking ? "Stop" : "Listen";

  const tooltip = isMuted
    ? "Guided tour audio is muted"
    : !speechSupported
      ? "Speech is not supported in this browser"
      : !text
        ? "No narration for this step"
        : isSpeaking
          ? "Stop guided tour narration"
          : "Listen to this step";

  const handleClick = () => {
    if (isSpeaking) {
      onStop();
    } else {
      onListen();
    }
  };

  return (
    <Tooltip title={tooltip}>
      <span>
        <Button
          size="small"
          variant="outlined"
          color={isSpeaking ? "secondary" : "primary"}
          startIcon={isSpeaking ? <StopIcon /> : <VolumeUpIcon />}
          onClick={handleClick}
          disabled={disabled}
          aria-label={label}
          sx={GUIDED_TOUR_ACTION_BUTTON_SX}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
